import { ConnectingAirportsOutlined } from "@mui/icons-material";
import useModels from "../../models";

const useGeneralHooks = () => {
  // Models
  const { useSelectors } = useModels();
  const { useSelector, useAuthSelectors } = useSelectors();
  const { session } = useAuthSelectors();
  const userSession = useSelector(session);

  const convertDateForIos = (date) => {
    const arr = date.split(/[- : T .]/);
    date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    return date;
  };

  // convert date in whatever format that you want
  const formatDate = (date, format = "Y-mm-dd", convert = true) => {
    if (convert)
        date = new Date(convertDateForIos(date))

    const map = {
      dd: date.getDate(),
      mm: date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1),
      Y: date.getFullYear(),
      yy: date.getFullYear().toString().slice(-2),
      HH: date.getHours() > 9 ? date.getHours() : "0" + date.getHours(),
      MM: date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes(),
      SS: date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds(),
    };

    return format.replace(/dd|mm|yy|Y|HH|MM|SS/gi, (matched) => map[matched]);
  };

  // convert date to this format (yyyy-mm-dd) to send to the back
  const dateFormatUTC = (FieldsDate) => {
    const date = formatDate(new Date(FieldsDate[0]), "Y-mm-dd", false);
    const time = new Date(FieldsDate[1]);
    const hour =
      FieldsDate[2] === "pm" && time.getHours() < 12 ? time.getHours() + 12 : time.getHours();

    return new Date(
      `${date}T${hour.toString().padStart(2, "0")}:${time
        .getMinutes()
        .toString()
        .padStart(2, "0")}:00`
    );
  };

  const prepareDataFilterDownload = (filters) => {
    const objFiltersKeys = Object.keys(filters)
    .filter((key) => filters[key] !== "")
    .map((item) => {
      if (filters[item] !== null && typeof filters[item] === "object"){
        return filters[item].map(v => {return `${item}[]=${v}`}).join('&')
      } else {
        return `${item}=${filters[item]}`;
      }
    });
    
    const stringDownloadFilter = objFiltersKeys.toString().replace(/,/g, "&");

    return stringDownloadFilter !== "" ? `?${stringDownloadFilter}` : "?";
  };

  const createDownloadExel = (response) => {
    let filename = `${Date.now()}.${response.data.type.split("/")[1]}`
    if(response.request.getResponseHeader('Content-Disposition')){
      const name = response.request.getResponseHeader('Content-Disposition') ?? Date.now();
      let startFileNameIndex = name.indexOf('"') + 1
      let endFileNameIndex = name.lastIndexOf('"');
      filename = name.substring(startFileNameIndex, endFileNameIndex);
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
  };

  /**
   * Filter countries based on logged-in user's assigned country_id array
   * @param {Array} allCountries - Full list of countries from API in format [{id, name, ...}, ...]
   * @returns {Array} - Filtered countries in {label, value} format matching user's country_id
   */
  const filterCountriesByUserAccess = (allCountries) => {
    const userCountryIds = userSession?.country_id || [];
    
    // If user has no country restrictions, return all countries
    if (!userCountryIds || userCountryIds.length === 0) {
      return allCountries.map((v) => ({ label: v.name, value: v.id }));
    }

    // Convert string IDs to numbers for comparison (backend sends ["48", "62"])
    const normalizedUserCountryIds = userCountryIds.map(id => Number(id));

    // Filter countries to only those in user's country_id array
    return allCountries
      .filter(country => normalizedUserCountryIds.includes(country.id))
      .map((v) => ({ label: v.name, value: v.id }));
  };

  return { 
    dateFormatUTC, 
    formatDate, 
    prepareDataFilterDownload, 
    createDownloadExel,
    filterCountriesByUserAccess 
  };
};

export default useGeneralHooks;
